import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, lifecycle, withHandlers } from 'recompose';
import _ from 'lodash';
import { ui } from 'components';
import { getObjectFromQueryString } from 'utils';
import apiHOCs from 'components/apiHOCs';

import 'assets/screens.scss';
import './style.scss';

const CatalogScene = ({
  filtersListApiHOC: { filters },
  productsListApiHOC: {
    getProducts,
    isProductsListFetching,
  },
  products,
  selectedFilters,
  setFilters,
  sortProducts,
  activeIndex,
  setActiveIndex,
  location,
}) => (
  <div className="catalog-layout">
    <div className="catalog-layout__filter">
      {filters ?
        <ui.FiltersContainer
          filters={filters}
          selectedFilters={selectedFilters}
          setFilters={setFilters}
          onSelectChange={_.debounce(getProducts, 300)}
        /> : null}
    </div>
    <div className="catalog-layout__items">
      <ui.SortContainer
        products={products}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
      />
      <div className="catalog-layout__products">
        {
          isProductsListFetching ?
            <ui.LoadingSpinner style={{ width: '100%' }} fullSize /> :
            products.length ?
              sortProducts(products)
                .map(product => <ui.ProductCard key={product.id} {...product} />) :
              <div className="catalog-layout__products__empty">По заданным фильтрам продукции не найдено</div>
          // if fetching - loader, else if products_array not empty - products, else empty message
        }
      </div>
    </div>
    {console.log(selectedFilters)}
  </div>
);

CatalogScene.propTypes = {
  filtersListApiHOC: PropTypes.shape({
    filters: PropTypes.object,
  }).isRequired,

  productsListApiHOC: PropTypes.shape({
    getProducts: PropTypes.func,
    isProductsListFetching: PropTypes.bool,
  }).isRequired,

  products: PropTypes.array,
  selectedFilters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  sortProducts: PropTypes.func.isRequired,
  activeIndex: PropTypes.number.isRequired,
  setActiveIndex: PropTypes.func.isRequired,
};

export default compose(
  withState('activeIndex', 'setActiveIndex', 0),
  withState('products', 'setProducts', []),
  withState('selectedFilters', 'setFilters', {}),

  apiHOCs.FiltersListApiHOC(),
  apiHOCs.ProductsListApiHOC({ getFilters: props => props.selectedFilters }),

  lifecycle({
    componentWillReceiveProps(nextProps) {
      if (this.props.productsListApiHOC.products !== nextProps.productsListApiHOC.products) {
        this.props.setProducts(nextProps.productsListApiHOC.products);
      }
    },
    componentDidMount() {
      if (this.props.location.search) {
        this.props.setFilters(getObjectFromQueryString(this.props.location.search));
        this.props.productsListApiHOC.getProducts({
          filters: getObjectFromQueryString(this.props.location.search),
        });
      }
    },
  }),

  withHandlers({
    sortProducts: ({ activeIndex, products }) => () => {
      switch (activeIndex) {
        case 1: {
          return products.sort((a, b) => (a.price - a.saleAmount) - (b.price - b.saleAmount));
        }
        case 2: {
          return products.sort((a, b) => (b.price - b.saleAmount) - (a.price - a.saleAmount));
        }
        default: {
          return products.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        }
      }
    },
  }),
)(CatalogScene);



// WEBPACK FOOTER //
// ./src/scenes/CatalogScene/index.js